import { DividendStatusType } from "@core/enums/dividend/dividend-status-type";
import { Dividend } from "@core/models/dividend-model";
import { Utilities } from "@core/utils/utils";

export class DividendHelper {
  static convertDates(dividend: Partial<Dividend>): void {
    if (dividend.announcementDate instanceof Date) {
      dividend.announcementDate?.toISOString();
    }
    if (dividend.recordDate instanceof Date) {
      dividend.recordDate?.toISOString();
    }
    if (dividend.exDividendDate instanceof Date) {
      dividend.exDividendDate?.toISOString();
    }
    if (dividend.paymentDate instanceof Date) {
      dividend.paymentDate?.toISOString();
    }
  }

  static convertPercentagesToNumber(dividend: Partial<Dividend>): void {
    if (dividend.percentage) {
      dividend.percentage = Utilities.convertPercentageToNumber(
        dividend.percentage.toString()
      );
    }
    if (dividend.defaultTaxWithHolding) {
      dividend.defaultTaxWithHolding = Utilities.convertPercentageToNumber(
        dividend.defaultTaxWithHolding.toString()
      );
    }
  }

  static convertDividendStatus(dividend: Partial<Dividend>): void {
    dividend.dividendStatus =
      DividendStatusType[
        dividend.dividendStatus as unknown as keyof typeof DividendStatusType
      ];
  }
}
